// Referral code capture for `?ref=CODE` share links (README §4.10 / §4.11).
//
// The code arrives in the URL when an invited person lands on /signup?ref=CODE.
// We stash it in localStorage so it survives the things that happen between
// landing and account creation: choosing a role, the OAuth round-trip to
// Google/Apple, and the redirect into onboarding. Both signup paths read it
// back — email/password sends it as the `referralCode` mutation variable; the
// OAuth buttons forward it on the request-phase URL.

const STORAGE_KEY = "jynio_referral_code";

// Read `?ref=` from the current URL and persist it. Call on the signup page
// mount. A new code overwrites an older stored one; an absent param leaves any
// previously-stored code intact (so landing on /signup directly still works).
export function captureReferralFromUrl(): void {
  try {
    const code = new URLSearchParams(window.location.search).get("ref")?.trim();
    if (code) localStorage.setItem(STORAGE_KEY, code);
  } catch {
    // localStorage can throw in private mode / when disabled — referral capture
    // is best-effort and must never block signup.
  }
}

export function getStoredReferralCode(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)?.trim() || null;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
